import React, { Component } from 'react';
import { Markup } from 'interweave';
import ReactPlayer from 'react-player';
import { QuestionTypes } from '../../../constants/QuestionTypes';
import MCViewer from './QA_Viewer/multipleChoice_viewer';
import MatrixViewer from './QA_Viewer/matrix_viewer';
import DropdownViewer from './QA_Viewer/dropdown_viewer';
import PicklistViewer from './QA_Viewer/picklist_viewer';
import CheckboxViewer from './QA_Viewer/checkbox_viewer';
import { isNullOrEmpty } from '../../common/commonFuncs';
import Tooltip from '@material-ui/core/Tooltip';
import * as Icon from 'react-feather';
import InstitutionViewer from "./QA_Viewer/institution_viewer";
import { TextArea } from 'semantic-ui-react';

class QAViewer extends Component {
	state = {
		Widget_ID: 0,
		Widget_Type: 0,
		Question_ID: this.props.Question_ID ? this.props.Question_ID : null,
		Question_Type_ID: 0,
		Question_Text: '',
		Description: '',
		Indicate_Response: false,
		Response_Required: false,
		Align_Horizontal: false,
		Allow_Multiple_Selection: false,
		Response: { Answer_ID: null, Answer_Text: '' },
		Matrix_Questions: [],
		Matrix_Answers: [],
		error_status: false,
		SurveyMode: this.props.SurveyMode ? true : false,
		PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : '',
		Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
		Form_ID: this.props.Form_ID ? this.props.Form_ID : 0,
		Form_BehaviorOnLoad: this.props.Form_BehaviorOnLoad ? this.props.Form_BehaviorOnLoad : null,
		selectedInst: this.props.selectedInst,
		preloadQAData: null,
		loading: true,
		Form_SecondaryIDName : this.props.Form_SecondaryIDName ? this.props.Form_SecondaryIDName : null,
		Form_SecondaryIDValue : this.props.Form_SecondaryIDValue ? this.props.Form_SecondaryIDValue : null,
		widgetsQA: this.props.widgetsQA ? this.props.widgetsQA : [],
		preloadFormData: this.props.preloadFormData ? this.props.preloadFormData : [],
	};

	async componentDidMount() {
		//Get config -> get data -> display form			
		this.getConfig()
		this.getPreloadData()
		this.setState({ loading: false });
	}

	getConfig() {
		let Widget_ID = this.props.Widget_ID,
			widgetsQA = this.state.widgetsQA,
			data = {},
			wQAs = [],
			tempWQA = [];

		widgetsQA && (tempWQA = (widgetsQA.filter((w) => w.Widget_ID == parseInt(Widget_ID))));
		if (tempWQA.length > 0) {
			let tempObj = {
				'Question_Config': [
					{
						'Question_ID': tempWQA[0].Question_ID,
						'Question_Type_ID': tempWQA[0].Question_Type_ID,
						'Question_Text': tempWQA[0].Question_Text,
						'Description': tempWQA[0].Description,
						'Indicate_Response': tempWQA[0].Indicate_Response,
						'Align_Horizontal': tempWQA[0].Align_Horizontal,
						'Allow_Multiple_Selection': widgetsQA.some((w)=>w.Allow_Multiple_Selection === true && w.Widget_ID===parseInt(Widget_ID)),
						'Linked_Question_ID': tempWQA[0].Linked_Question_ID,
						'Response_Required': tempWQA[0].Response_Required,
						'Custom_Render': tempWQA[0].Custom_Render
					}],
				'QuestionAnswers_Config': []
			}
			widgetsQA.forEach(
				function (widget) {
					if (widget.Widget_ID == parseInt(Widget_ID) && ((widgetsQA.filter((w) => w.Widget_ID == Widget_ID)).length > 0)) {
						tempObj['QuestionAnswers_Config'].push({
							'Answer_ID': widget.Answer_ID,
							'Answer_Number': widget.Answer_Number,
							'Answer_Text': widget.Answer_Text
						})
					}
				}
			)
			wQAs.push(tempObj)
		}
		
		let matrixQA = tempWQA.filter((el)=>el.Linked_Question_ID!==null), Matrix_Questions=[...this.state.Matrix_Questions], Matrix_Answers=[...this.state.Matrix_Answers];
		matrixQA.forEach(
			function (widget) {
				Matrix_Questions = [
					...Matrix_Questions,
					{
						Question_ID: widget.Question_ID,
						Question_Text: widget.Question_Text,
						Question_Type_ID: widget.Question_Type_ID,
						Description: widget.Description,
						Deleted: widget.Deleted
					}
				];
				Matrix_Answers=[
					...Matrix_Answers,{
						'Question_ID': widget.Question_ID,
						'Answer_ID': widget.Answer_ID,
						'Answer_Number': widget.Answer_Number,
						'Answer_Text': widget.Answer_Text
					}
				]
			})
		this.setState({ Matrix_Questions, Matrix_Answers });

		data = wQAs[0]['Question_Config'];
		
		let Indicate_Response = false, Response_Required = false;
		if (data[0]) {
			let Response_Required = data[0].Response_Required === null ? false : data[0].Response_Required;
			this.setState({ Question_ID: tempWQA[0].Question_ID });
			this.setState({ Response_Required });
			if (data[0].Linked_Question_ID == null) {
				this.setState({ Question_ID: data[0].Question_ID });
				this.setState({ Question_Type_ID: data[0].Question_Type_ID });
				const Question_Text = data[0].Question_Text.replace('</p><p>', '<br />').replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '');
				this.setState({ Question_Text });
				this.setState({ Description: data[0].Description });
				Indicate_Response = data[0].Indicate_Response;
				this.setState({ Indicate_Response });
				this.setState({ Align_Horizontal: data[0].Align_Horizontal });
				this.setState({
					Allow_Multiple_Selection: data[0].Allow_Multiple_Selection ? true : false,
				});
				this.setState({Custom_Render: data[0].Custom_Render})
			}
		}

		// Load question answers
		let Question_Answers = wQAs.length > 0 ? wQAs[0]['QuestionAnswers_Config'] : [];
		this.setState({ Question_Answers });
		if (Response_Required) {
			this.props.OnUpdate(this.props.Question_Number, {
				Responses: [],
				Response_Required: (this.state.Question_Type_ID === QuestionTypes.Checkbox) ? false : Response_Required,
			});
		}
		return Question_Answers ? 'success' : 'failed';

	}

	getPreloadData() {
		//Get recent saved data for a form with pk
		let Question_ID = this.state.Question_ID;
		if (this.state.Form_BehaviorOnLoad != 1 || (this.state.Form_BehaviorOnLoad === 1 && this.props.Form_BehaviorOnSave !== 2)) {
			let preloadQAData = this.state.preloadFormData.find(ques => parseInt(ques.Question_ID) === parseInt(Question_ID)), Response = {}
			Response.Question_ID = preloadQAData ? preloadQAData.Question_ID : null;
			Response.Answer_Text = preloadQAData ? preloadQAData.Answer_Text : null;
			Response.Answer_ID = preloadQAData ? preloadQAData.Answer_ID : null;
			this.setState({ Response, preloadQAData })
			this.handleSimpleInput(Response.Answer_Text, this.state.Question_Type_ID)
		}
		else {
			if (this.props.Form_BehaviorOnSave == 2) {
				Response.Question_ID = null;
				Response.Answer_Text = null
				Response.Answer_ID = null
				this.setState({ preloadQAData: null });
			}
		}
	}

	handleSimpleInput(value, type) {
		const {Question_Answers, Response_Required, SurveyMode } = this.state;
		if (SurveyMode) {
			if ((type === QuestionTypes.Numeric || type === QuestionTypes.Numeric_Tally) && value) {
        const [minObj,maxObj]=Question_Answers;
        const minimumValue = parseInt(minObj.Answer_Text);
        const maximumValue = parseInt(maxObj.Answer_Text);
				value = QuestionTypes.Numeric ? parseFloat(value) : parseInt(value);
				if (isNaN(value) || value < minimumValue || value > maximumValue) {
					this.setState({ error_status: true });
					return;
				}
			}

			let Response = { ...this.state.Response };
			Response.Answer_Text = value;
			this.setState({ error_status: false, Response });
			this.props.OnUpdate(this.props.Question_Number, {
				Responses: Response_Required && isNullOrEmpty(value) ? [] : [{ Question_Number:this.props.Question_Number, Question_ID: this.state.Question_ID, ...Response}],
				Response_Required: Response_Required,
				Question_Number:this.props.Question_Number
			});
		}
	}

	render() {
		const {
			loading,
			Question_Type_ID,
			Question_Text,
			Question_Answers,
			Question_ID,
			Matrix_Questions,
			Matrix_Answers,
			Widget_ID,
			Description,
			Indicate_Response,
			Align_Horizontal,
			Response_Required,
			Allow_Multiple_Selection,
			error_status,
			Response,
		} = this.state;

		if (loading) return <h2>Loading...</h2>;

		return (
			<div className='card-body'>
				<div className={Align_Horizontal ? 'd-flex justify-content-start' : ''}>
					<div className={Align_Horizontal ? 'col-sm-5' : 'col-sm-12'}>
						<h5 className='card-title'>
							<Markup tagName='inline' content={(Response_Required ? '*' : '') + 'Q' + (this.props.Question_Number + 1) + '. ' + Question_Text} />
							{Description && (
								<Tooltip title={Description} placement='top'>
									<Icon.Info size={18} />
								</Tooltip>
							)}

							{Indicate_Response && (
								<Tooltip title='Responded' placement='top'>
									<Icon.CheckCircle size={18} color='#00ac69' />
								</Tooltip>
							)}
						</h5>
					</div>

					<div className='col'>
						{
							// text questions
							Question_Type_ID === QuestionTypes.Text && (
								<input key={'W' + Widget_ID} type='text' className='form-control' value={Response.Answer_Text} onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)} />
							)
						}
						{
							// textarea question
							Question_Type_ID === QuestionTypes.Textarea && (
								<TextArea maxLength={500} key={'W' + Widget_ID} className='form-control' value={Response.Answer_Text} onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)} />
							)
						}
						{
							// identifier question
							Question_Type_ID === QuestionTypes.Identifier && (
								<input key={'W' + Widget_ID} type='text' className='form-control' value={Response.Answer_Text} onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)} />
							)
						}

						{
							// numeric/tally questions
							(Question_Type_ID === QuestionTypes.Numeric || Question_Type_ID === QuestionTypes.Numeric_Tally) && (
								<div className='form-row'>
									<div className='col-sm-6'>
										<input
											key={'W' + Widget_ID}
											type={Question_Type_ID === QuestionTypes.Numeric_Tally ? 'number' : 'text'}
											className={'form-control' + (error_status ? ' is-invalid' : '')}
											value={Response.Answer_Text}
											// onChange={(e) =>
											// 	this.handleSimpleInput(
											// 		e.target.value >= Question_Answers[0].Answer_Text && 
                      //     e.target.value <= Question_Answers[1].Answer_Text 
                      //     ? e.target.value : Response.Answer_Text,
											// 		Question_Type_ID
											// 	)
											// }
                      onChange={(e) =>
												this.handleSimpleInput(
                          e.target.value,
													Question_Type_ID
												)
											}
											min={Question_Answers[0].Answer_Text}
											max={Question_Answers[1].Answer_Text}
										/>
										<div className='invalid-feedback' key={'INVALIDQ' + Widget_ID}>
											Not a valid numeric entry
										</div>
									</div>
								</div>
							)
						}

						{
							// video questions
							Question_Type_ID === QuestionTypes.Video && <ReactPlayer key={'W' + Widget_ID} url={Question_Answers[0].Answer_Text} controls={true} />
						}

						{
							// date questions
							Question_Type_ID === QuestionTypes.Date && (
								<div className='form-group row' key={'W' + Widget_ID}>
									<div className='col-sm-6'>
										<input key={'date' + Widget_ID} type='date' className='form-control' value={Response.Answer_Text} onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)} />
									</div>
								</div>
							)
						}

						{
							// time questions
							Question_Type_ID === QuestionTypes.Time && (
								<div className='form-group row' key={'W' + Widget_ID}>
									<div className='col-sm-6'>
										<input
											key={'time' + Widget_ID}
											type='time'
											className='form-control'
											value={Response.Answer_Text}
											//step='1'
											onChange={(e) => this.handleSimpleInput(e.target.value, Question_Type_ID)}
										/>
									</div>
								</div>
							)
						}

						{
							// Multiple Choice
							Question_Type_ID === QuestionTypes.Multiple_Choice && (
								<MCViewer
									key={'W' + Widget_ID}
									OnUpdate={this.props.OnUpdate}
									Question_ID={Question_ID}
									Question_Number={this.props.Question_Number}
									Question_Answers={Question_Answers}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={Response.Answer_ID}
									isMultiple={Allow_Multiple_Selection}
									SurveyMode={this.state.SurveyMode}
									preloadQAData={this.state.preloadQAData}
									CliValidation_Action={this.props.CliValidation_Action}
								/>
							)
						}

						{
							// Scale questions
							Question_Type_ID === QuestionTypes.Scale && (
								<MCViewer
									key={'W' + Widget_ID}
									OnUpdate={this.props.OnUpdate}
									Question_ID={Question_ID}
									Question_Number={this.props.Question_Number}
									Question_Answers={Question_Answers}
									isScale={true}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={Response.Answer_ID}
									SurveyMode={this.state.SurveyMode}
									preloadQAData={this.state.preloadQAData}
								/>
							)
						}

						{
							// Matrix questions
							Question_Type_ID === QuestionTypes.Matrix && (
								<MatrixViewer
									key={'W' + Widget_ID}
									Question_ID={Question_ID}
									OnUpdate={this.props.OnUpdate}
									Question_Answers={Question_Answers}
									Matrix_Questions={Matrix_Questions}
									Matrix_Answers={Matrix_Answers}
									isMultiple={Allow_Multiple_Selection}
									Question_Number={this.props.Question_Number}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
								/>
							)
						}

						{
							// Dropdown questions
							Question_Type_ID === QuestionTypes.Dropdown && (
								<DropdownViewer
									key={'W' + Widget_ID}
									Question_ID={Question_ID}
									OnUpdate={this.props.OnUpdate}
									Question_Number={this.props.Question_Number}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={Response.Answer_ID}
									isMultiple={Allow_Multiple_Selection}
									preloadQAData={this.state.preloadQAData}
								/>
							)
						}

						{
							// Dropdown question for Institution
							Question_Type_ID === QuestionTypes.Institution && (
								<InstitutionViewer
									key={'W' + Widget_ID}
									Question_ID={Question_ID}
									OnUpdate={this.props.OnUpdate}
									Question_Number={this.props.Question_Number}
									Response_Required={Response_Required}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={this.state.selectedInst}
									isMultiple={Allow_Multiple_Selection}
									selectedInst= {this.state.selectedInst}
								/>
							)
						}

						{Question_Type_ID === QuestionTypes.Picklist && (
							<PicklistViewer
								key={'W' + Widget_ID}
								Question_ID={Question_ID}
								OnUpdate={this.props.OnUpdate}
								Question_Answers={Question_Answers}
								Question_Number={this.props.Question_Number}
								Response_Required={Response_Required}
								PrimaryKey={this.state.PrimaryKey}
								Project_ID={this.state.Project_ID}
								Answer_ID={Response.Answer_ID}
								preloadQAData={this.state.preloadQAData}
								selectedInst= {this.state.selectedInst}
								Custom_Render={this.state.Custom_Render}
							/>
						)}

						{Question_Type_ID === QuestionTypes.Checkbox && (
							<CheckboxViewer
								key={'W' + Widget_ID}
								Question_ID={Question_ID}
								Question_Answers={Question_Answers}
								Question_Number={this.props.Question_Number}
								Response_Required={Response_Required}
								PrimaryKey={this.state.PrimaryKey}
								Project_ID={this.state.Project_ID}
								Answer_ID={Question_Answers[0].Answer_ID}
								SurveyMode={this.state.SurveyMode}
								Widget_ID={this.props.Widget_ID}
								OnUpdate={this.props.OnUpdate}
								preloadQAData={this.state.preloadQAData}
							/>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default QAViewer;
